const preStyle = {
  fonts: ["Akaya Telivigala", "Bebas Neue", "Dancing Script", "Indie Flower"],
  heights: ["150px", "120px", "100px", "130px", "140px", "135px"],
  textures: [
    "https://www.transparenttextures.com/patterns/binding-light.png",
    "https://www.transparenttextures.com/patterns/black-orchid.png",
    "https://www.transparenttextures.com/patterns/dark-exa.png",
    "https://www.transparenttextures.com/patterns/light-sketch.png"
  ],
  colors: [
    "#3f51b5",
    "#5c6bc0",
    "#7986cb",
    "#9fa8da",
    "#c5cae9",
    "#283593",
    "#1a237e"
  ],
  fontColors: ["white", "white", "black", "black", "white", "black", "black"]
};

export default preStyle;
